// extracted by mini-css-extract-plugin
module.exports =  {"fullscreen":"_0d624b9a27--fullscreen--h_lwE"};